import React from 'react';
import { Card } from '../components/ui/card';

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl font-display font-normal mb-8">Privacy Policy</h1>
        
        <Card className="p-6 space-y-6">
          <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'long', year: 'numeric' })}</p>

          <section>
            <h2 className="text-xl font-semibold mb-3">Introduction</h2>
            <p className="text-muted-foreground">
              Tiffin and Bag, operated by F Square Media ("we", "our", "us") respects your privacy and is committed to protecting your personal data. 
              This privacy policy explains how we collect, use, and safeguard your information when you visit our website at tiffinandbag.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Information We Collect</h2>
            <h3 className="text-lg font-semibold mt-4 mb-2">Personal Information</h3>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong>Contact Details:</strong> Name, phone number, delivery address</li>
              <li><strong>Order Information:</strong> Purchase history, product preferences</li>
              <li><strong>Payment Information:</strong> Processed securely through Razorpay (we don't store card details)</li>
            </ul>
            
            <h3 className="text-lg font-semibold mt-4 mb-2">Automatically Collected Information</h3>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Device information and browser type</li>
              <li>IP address and location data</li>
              <li>Cookies and tracking technologies</li>
              <li>Pages viewed and interactions on our website</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Process and fulfill your orders</li>
              <li>Send order updates and delivery notifications via WhatsApp</li>
              <li>Provide customer support</li>
              <li>Improve our products and services</li>
              <li>Send promotional offers (with your consent)</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">WhatsApp Communication</h2>
            <p className="text-muted-foreground">
              We use WhatsApp for OTP authentication and order updates. By using our service, you consent to receive 
              transactional messages via WhatsApp. We use Interakt for WhatsApp Business API integration.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Payment Security</h2>
            <p className="text-muted-foreground">
              All payments are processed through Razorpay, a secure payment gateway. We do not store your credit card 
              or banking information on our servers. Razorpay is PCI-DSS compliant and uses industry-standard encryption.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Cookies and Tracking</h2>
            <p className="text-muted-foreground">
              We use cookies and similar technologies to enhance your browsing experience, analyze website traffic, 
              and show personalized ads. We use Facebook Pixel to track conversions and optimize our marketing campaigns.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Third-Party Services</h2>
            <p className="text-muted-foreground mb-2">We share data with trusted third-party services:</p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong>Razorpay:</strong> Payment processing</li>
              <li><strong>Interakt:</strong> WhatsApp messaging</li>
              <li><strong>Cloudflare:</strong> Image hosting and CDN</li>
              <li><strong>Facebook:</strong> Advertising and analytics</li>
              <li><strong>Courier Partners:</strong> Order delivery</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Data Security</h2>
            <p className="text-muted-foreground">
              We implement appropriate security measures to protect your personal information from unauthorized access, 
              alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Your Rights</h2>
            <p className="text-muted-foreground mb-2">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Withdraw consent for data processing</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Children's Privacy</h2>
            <p className="text-muted-foreground">
              Our products are for children, but our website is intended for use by adults (parents/guardians). 
              We do not knowingly collect personal information from children under 18.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Changes to This Policy</h2>
            <p className="text-muted-foreground">
              We may update this privacy policy from time to time. We will notify you of any changes by posting the 
              new policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <p className="text-muted-foreground">
              If you have questions about this privacy policy or want to exercise your rights, contact us at:
            </p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li><strong>F Square Media</strong></li>
              <li>Address: Panchsheel Park, New Delhi - 110017</li>
              <li>Email: motheringin@gmail.com</li>
              <li>Phone/WhatsApp: +91 80621 80632</li>
            </ul>
          </section>
        </Card>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;